import React from "react";
import { ArrowLeft } from "lucide-react";
import logoutIcon from "../../assets/icons/logout.svg";
import welcome from "../../assets/images/welcome.svg";
import clock from "../../assets/icons/clock.svg";
import info from "../../assets/icons/info.svg";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Welcome() {
  const { handleLogout, user } = useAuth();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const storeEmailInLocalStorage = (email) => {
    try {
      const storedEmails =
        JSON.parse(localStorage.getItem("verifiedEmails")) || [];
      if (!storedEmails.includes(email)) {
        storedEmails.push(email);
        localStorage.setItem("verifiedEmails", JSON.stringify(storedEmails));
      }
    } catch (error) {
      console.error("Error handling localStorage emails:", error);
    }
  };

  return (
    <div className="min-h-screen flex flex-col overflow-y-auto w-full ">
      <div className="flex  border-0 justify-between items-center pt-[3.75rem] pb-[1.75rem] lg:pt-[1.75rem] lg:px-16 px-5 lg:pb-[1.5rem] lg:border lg:border-b lg:border-b-[#EBE9EF]">
        <button
          onClick={handleBack}
          className=" w-12 h-12 flex items-center justify-center rounded-full border border-[#EBE9EF] invisible"
        >
          <ArrowLeft className="w-5 h-5 text-[#6D6584]" />
        </button>

        <p className="font-plusjakarta font-[600] font-semibold text-[16px] lg:text-[20px] leading-[24px] tracking-normal text-center text-[#33125F]">
          Complete profile
        </p>
        <button className="w-12 h-12 flex items-center lg:hidden block justify-center rounded-full border border-[#EBE9EF]">
          <img src={logoutIcon} alt="" className="w-[16px] h-[16px]" />
        </button>

        <button
          onClick={handleLogout}
          className="rounded-full border lg:block hidden border-[#EBE9EF] flex items-center justify-center px-5 py-[13px] text-[14px] font-medium text-[#6D6584]"
        >
          Log out
        </button>
      </div>
      <div className=" h-[4px] bg-gray-200 rounded-full w-full lg:hidden block ">
        {" "}
      </div>
      <div className="z-10 mt-[1.5rem]  flex flex-col items-center justify-center ">
        <div className="lg:mt-[80px] mt-[25px]">
          <img
            src={welcome}
            alt="Welcome Illustration"
            className="mx-auto w-[194px] h-[136px]"
          />
        </div>
        <p className="font-plusjakarta font-semibold text-[32px] leading-[40px] tracking-normal text-center text-[#33125F] mt-7 mb-7 lg:block hidden">
          Welcome to 80eight!
        </p>
        <p className="font-plusjakarta font-semibold text-[32px] leading-[40px] tracking-normal text-center text-[#33125F] mt-7 mb-7 lg:hidden block">
          Hello!
        </p>
        <div className="lg:max-w-[548px] max-w-[306px]">
          <p className="font-plusjakarta font-normal text-[16px] leading-[24px] tracking-normal text-center mb-7 text-[#423E51]">
            Before you can start using your account, we need to securely verify
            your personal information and ID.
          </p>
          <p className="font-plusjakarta font-normal text-[16px] leading-[24px] tracking-normal text-center mb-7 text-[#423E51]">
            It only takes a few minutes, and it keeps your account safe and
            compliant. Let's get started.
          </p>
          <div className="w-[95px] mx-auto font-semibold flex items-center justify-center gap-1 rounded-full px-4 py-2 text-[14px] bg-[#F1EDF7] text-[#57249C] mb-5">
            <img src={clock} alt="" className="w-[16px] h-[16px]" /> 5 mins
          </div>
          <div
            className={`mt-5 mx-auto h-[78px] lg:w-[358px] w-[308px] p-4 rounded-[16px] flex justify-center gap-2 font-semibold text-[14px] text-white transition-transform duration-200 shadow-lg bg-[#6375E6] mb-10`}
          >
            <img src={info} alt="" className="w-[16px] h-[16px] mt-1" />
            Keep your ID/Passport document on hand for the verification step.
          </div>
        </div>

        <div className="w-[100%] gap-4 flex flex-col justify-center items-center lg:mt-0 my-5">
          <button
            onClick={() => {
              storeEmailInLocalStorage(user?.email);
              navigate("/complete-profile");
            }}
            className={`bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white flex items-center justify-center font-semibold text-[14px] font-[400] px-8 lg:py-[11px] py-[12px] rounded w-[308px] lg:w-[358px] rounded-full transition duration-300 ease-in-out hover:scale-[1.1] `}
          >
            Let's go!
          </button>
        </div>
      </div>
      <div className="mt-auto  border border-[#EBE9EF] flex justify-center items-center left-0 w-full lg:px-[23px] px-[27px] lg:pt-[23px] pt-[15px] lg:pb-[23px] pb-[35px]">
        <p className="font-plusjakarta font-normal text-[16px] leading-[24px] tracking-normal text-[#423E51]">
          Already have an account?{" "}
          <p
            onClick={handleLogout}
            className="text-[#33125F] font-semibold ml-2 inline cursor-pointer"
          >
            Sign in
          </p>
        </p>
      </div>
    </div>
  );
}
